import { FloatingPortal } from "@floating-ui/react"
import clsx from "clsx"
import { forwardRef, type HTMLAttributes, type ReactNode } from "react"
import type { CompoundedComponent } from "@/shared/types"

import "./style.scss"
import { Icon, type IconName } from "@/shared/components/ui/icon"

interface MenuProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode[] | ReactNode
  open: boolean
}

const Menu = forwardRef<HTMLDivElement, MenuProps>(({ children, open, ...props }, ref) => {
  if (!open) return null
  return (
    <FloatingPortal>
      <div {...props} ref={ref} className={clsx("custom-menu", props.className)}>
        {children}
      </div>
    </FloatingPortal>
  )
}) as CompoundedComponent<MenuProps, HTMLDivElement, { Item: typeof MenuItem }>

interface MenuItemProps extends HTMLAttributes<HTMLDivElement> {
  icon?: IconName
  label: string
  render?: (icon?: IconName, label?: string) => ReactNode
}
const MenuItem = ({ children, icon, label, render, ...props }: MenuItemProps) => {
  return (
    <div {...props} className={clsx("custom-menu-item", props.className)}>
      {render != null ? (
        render(icon, label)
      ) : (
        <>
          {icon && (
            <div className="custom-menu-item__icon">
              <Icon size={22} name={icon} />
            </div>
          )}
          <span className="custom-menu-item__label">{label}</span>
        </>
      )}
    </div>
  )
}

Menu.Item = MenuItem
export default Menu
